export default __webpack_public_path__ + "static/2-fitness-638da07544e36acb49f78560f4633560.png";